<ng-container *ngIf="properties | async as props">
  <ng-container *ngFor="let filter of props; let i = index">
    <ng-container>
      <div class="main-container {{ filter.customClass }} "
        [style.top.px]="filter.topPosition ? filter.topPosition : 10"
        [style.left.px]="filter.leftPosition ? filter.leftPosition : 0">
        <div class="filter-container text-white">
          <div class="header d-flex align-items-center" (click)="onShowFilter(i)">
            <h2 class="title">
              {{ filter.title }}
            </h2>
            <div id="{{filter.title}}" class="d-flex text-color-white justify-end cursor-pointer ml-8">

              <sit-icon class="icon-white" [alt]="'Cerrar'" [icon]="Icon.expand" [sizeClass]="'icon-size-18'"
                style="display: flex; align-items: center;"></sit-icon>

              <sit-icon class="icon-black" [alt]="'Cerrar'" [icon]="Icon.expand_b"
                [sizeClass]="'icon-size-18'"></sit-icon>

            </div>
          </div>
          <div class="content" *ngIf="filterShow[i]">
            <ng-container *ngIf="filter.content as toRender">
              <sit-renderer [toRender]="toRender"></sit-renderer>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
